import request from '@/request/screenRequest';

// 获取船舶信息列表
// {
//   size: 10,
//   page: 1
// }
export function getShipList(params) {
  return request({
    method: 'get',
    url: '/api/tanker/tankerInfo',
    params,
  });
}

// 获取船舶附加信息列表
// {
//   size: 10,
//   page: 1
// }
// export function getAdditionList(params) {
//   return request({
//     method: 'get',
//     url: '/api/tanker/voyageInfo',
//     params,
//   });
// }
//获取船只信息
export function getShipInfo(params) {
  return request({
    method: 'get',
    url: `api/tanker/screenDispatch`,
    params,
  });
}
//获取管理成本
export function getCostInfo(params) {
  return request({
    method: 'get',
    url: `api/tanker/screenCost`,
    params,
  });
}

//获取货物配载数据
export function getStowageInfo(params) {
  return request({
    method: 'get',
    url: `api/tanker/stowage/display`,
    params,
  });
}

//获取港口数据
export function getPortInfo(params) {
  return request({
    method: 'get',
    url: `api/tanker/stowage/portInfo`,
    params,
  });
}

// // 退出登录
// export function logout(data) {
//   return request({
//     method: 'post',
//     url: '/api/screen/logout',
//     data,
//   });
// }
// 退出登录
export function logout(data) {
  return request({
    method: 'post',
    url: '/api/logout',
    data,
  });
}
